"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1319],{

/***/ 94306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ BaseBlock; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32317);
/* harmony import */ var _styles_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45500);
/* harmony import */ var baseui_block__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81480);
/* harmony import */ var _hooks_use_overrides__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58817);










var BaseBlockComponent = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var children = _param.children, overrides = _param.overrides, className = _param.className, columnGap = _param.columnGap, rowGap = _param.rowGap, flexbox = _param.flexbox, cursor = _param.cursor, column = _param.column, flexCenter = _param.flexCenter, borderRadius = _param.rounded, boxSizing = _param.boxSizing, spaceBetween = _param.spaceBetween, alignCenter = _param.alignCenter, justifyCenter = _param.justifyCenter, zIndex = _param.zIndex, border = _param.border, userSelect = _param.userSelect, onClick = _param.onClick, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children",
        "overrides",
        "className",
        "columnGap",
        "rowGap",
        "flexbox",
        "cursor",
        "column",
        "flexCenter",
        "rounded",
        "boxSizing",
        "spaceBetween",
        "alignCenter",
        "justifyCenter",
        "zIndex",
        "border",
        "userSelect",
        "onClick"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_block__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        onClick: onClick,
        ref: ref,
        className: className,
        overrides: (0,_hooks_use_overrides__WEBPACK_IMPORTED_MODULE_6__/* .useOverrides */ .Q)({
            Block: {
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    columnGap: columnGap,
                    rowGap: rowGap,
                    boxSizing: boxSizing
                }, borderRadius && (0,_styles_utils__WEBPACK_IMPORTED_MODULE_7__/* .rounded */ .eP)(borderRadius), flexbox && {
                    display: "flex"
                }, column && {
                    flexDirection: "column"
                }, flexCenter && {
                    justifyContent: "center",
                    alignItems: "center"
                }, spaceBetween && {
                    justifyContent: "space-between"
                }, cursor && {
                    cursor: cursor
                }, alignCenter && {
                    alignItems: "center"
                }, justifyCenter && {
                    justifyContent: "center"
                }, zIndex && {
                    zIndex: zIndex
                }, border && (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (0,_styles_utils__WEBPACK_IMPORTED_MODULE_7__/* .border */ .Cg)(border.color || _styles_colors__WEBPACK_IMPORTED_MODULE_8__/* .colors.gray700 */ .O.gray700, border.width, border.style)), userSelect && {
                    userSelect: userSelect
                })
            }
        }, overrides)
    }, props), {
        children: children
    }));
});
var BaseBlock = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(BaseBlockComponent);


/***/ }),

/***/ 74732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ BasePopover; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_hooks_use_overrides__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58817);
/* harmony import */ var baseui_popover__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78048);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43281);







var BasePopover = function(_param) {
    var children = _param.children, overrides = _param.overrides, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "overrides"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_popover__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        focusLock: true,
        returnFocus: true,
        renderAll: true,
        autoFocus: false,
        overrides: (0,_components_hooks_use_overrides__WEBPACK_IMPORTED_MODULE_5__/* .useOverrides */ .Q)({
            Body: {
                style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    marginTop: "4px"
                }, (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .borderRadius */ .E0)("top", "16px"), (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .borderRadius */ .E0)("bottom", "16px")), {
                    boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
                    zIndex: 999
                })
            },
            Inner: {
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    backgroundColor: "white"
                }, (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .borderRadius */ .E0)("top", "16px"), (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .borderRadius */ .E0)("bottom", "16px"))
            }
        }, overrides)
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 88292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sj": function() { return /* binding */ ParagraphXS; },
/* harmony export */   "Sl": function() { return /* binding */ ParagraphM; },
/* harmony export */   "fw": function() { return /* binding */ ParagraphS; },
/* harmony export */   "q9": function() { return /* binding */ ParagraphL; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var baseui_typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94858);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32317);







var ParagraphL = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, weight = _param.weight, align = _param.align, _color = _param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray700 */ .O.gray700 : _color, $style = _param.$style, whiteSpace = _param.whiteSpace, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "weight",
        "align",
        "color",
        "$style",
        "whiteSpace"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_typography__WEBPACK_IMPORTED_MODULE_4__/* .ParagraphLarge */ .kd, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        font: "ParagraphL",
        $style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            fontWeight: weight,
            textAlign: align,
            whiteSpace: whiteSpace
        }, $style),
        color: color
    }, props), {
        ref: ref,
        children: children
    }));
});
var ParagraphM = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, weight = _param.weight, align = _param.align, _color = _param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray700 */ .O.gray700 : _color, $style = _param.$style, whiteSpace = _param.whiteSpace, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "weight",
        "align",
        "color",
        "$style",
        "whiteSpace"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_typography__WEBPACK_IMPORTED_MODULE_4__/* .ParagraphMedium */ .Yl, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        font: "ParagraphM",
        $style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            fontWeight: weight,
            textAlign: align,
            whiteSpace: whiteSpace
        }, $style),
        color: color
    }, props), {
        ref: ref,
        children: children
    }));
});
var ParagraphS = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, weight = _param.weight, align = _param.align, _color = _param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray700 */ .O.gray700 : _color, whiteSpace = _param.whiteSpace, $style = _param.$style, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "weight",
        "align",
        "color",
        "whiteSpace",
        "$style"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_typography__WEBPACK_IMPORTED_MODULE_4__/* .ParagraphSmall */ .aM, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        font: "ParagraphS",
        $style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            fontWeight: weight,
            textAlign: align,
            whiteSpace: whiteSpace
        }, $style),
        color: color
    }, props), {
        ref: ref,
        children: children
    }));
});
var ParagraphXS = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, weight = _param.weight, align = _param.align, _color = _param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray700 */ .O.gray700 : _color, whiteSpace = _param.whiteSpace, $style = _param.$style, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "weight",
        "align",
        "color",
        "whiteSpace",
        "$style"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_typography__WEBPACK_IMPORTED_MODULE_4__/* .ParagraphSmall */ .aM, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        font: "ParagraphXS",
        $style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            fontWeight: weight,
            textAlign: align,
            whiteSpace: whiteSpace
        }, $style),
        color: color
    }, props), {
        ref: ref,
        children: children
    }));
});


/***/ }),

/***/ 95587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ BaseDrawer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_block__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(94306);
/* harmony import */ var _components_base_typography__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(67408);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(32079);
/* harmony import */ var _lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(60369);
/* harmony import */ var _lib_routes__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(78954);
/* harmony import */ var _modules_auth_hooks_use_logout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84322);
/* harmony import */ var _modules_users_hooks_use_me__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17243);
/* harmony import */ var _styles_box_shadow__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(24035);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(32317);
/* harmony import */ var _styles_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45500);
/* harmony import */ var baseui_drawer__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(32365);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(43281);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54511);





















var BaseDrawer = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,styletron_react__WEBPACK_IMPORTED_MODULE_5__/* .useStyletron */ .hQ)(), 1), css = ref1[0];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var logout = (0,_modules_auth_hooks_use_logout__WEBPACK_IMPORTED_MODULE_6__/* .useLogout */ .a)().logout;
    var me = (0,_modules_users_hooks_use_me__WEBPACK_IMPORTED_MODULE_7__/* .useMe */ .P)().me;
    var menuItemStyle = css((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        display: "flex",
        alignItems: "center",
        cursor: "pointer"
    }, (0,_styles_utils__WEBPACK_IMPORTED_MODULE_10__/* .transition */ .eR)("background-color", "0.2s"), (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .padding */ .o3)("16px", "16px")), {
        ":hover": {
            backgroundColor: _styles_colors__WEBPACK_IMPORTED_MODULE_12__/* .colors.gray50 */ .O.gray50
        }
    }));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_block__WEBPACK_IMPORTED_MODULE_13__/* .BaseBlock */ .v, {
                flexbox: true,
                flexCenter: true,
                display: [
                    "block",
                    "block",
                    "none",
                    "none"
                ],
                onClick: function() {
                    return setIsOpen(function(prev) {
                        return !prev;
                    });
                },
                cursor: "pointer",
                rounded: 8,
                className: css((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .padding */ .o3)("4px")), {
                    ":hover": {
                        backgroundColor: _styles_colors__WEBPACK_IMPORTED_MODULE_12__/* .colors.gray50 */ .O.gray50
                    }
                })),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_14__/* .Icon */ .J, {
                    type: "Navigation"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_drawer__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                autoFocus: false,
                renderAll: true,
                isOpen: isOpen,
                onClose: function() {
                    return setIsOpen(false);
                },
                overrides: {
                    Root: {
                        style: {
                            zIndex: 9999
                        }
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_block__WEBPACK_IMPORTED_MODULE_13__/* .BaseBlock */ .v, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: css({
                            overflow: "hidden"
                        }),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                className: css((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    rowGap: "8px"
                                }, (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .padding */ .o3)("20px", "16px"), (0,_styles_box_shadow__WEBPACK_IMPORTED_MODULE_16__/* .boxShadow */ .W)("borderBottom"))),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_typography__WEBPACK_IMPORTED_MODULE_17__/* .LabelS */ .ew, {
                                        children: [
                                            me === null || me === void 0 ? void 0 : me.nickname,
                                            "님"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_17__/* .LabelS */ .ew, {
                                        color: _styles_colors__WEBPACK_IMPORTED_MODULE_12__/* .colors.gray400 */ .O.gray400,
                                        children: me === null || me === void 0 ? void 0 : me.email
                                    })
                                ]
                            }),
                            (me === null || me === void 0 ? void 0 : me.role) === _lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_18__/* .UserRole.Admin */ .i4.Admin && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    onClick: function() {
                                        return setIsOpen(false);
                                    },
                                    children: router.pathname.includes("admin") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: _lib_routes__WEBPACK_IMPORTED_MODULE_19__/* .Routes.HOME */ .Z.HOME,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            className: menuItemStyle,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_17__/* .LabelS */ .ew, {
                                                    flex: "1 1 auto",
                                                    color: _styles_colors__WEBPACK_IMPORTED_MODULE_12__/* .colors.gray600 */ .O.gray600,
                                                    children: "온톨로 이동하기"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_14__/* .Icon */ .J, {
                                                    type: "ChevronRight",
                                                    size: 12
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: _lib_routes__WEBPACK_IMPORTED_MODULE_19__/* .AdminRoutes.HOME */ .i.HOME,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            className: menuItemStyle,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_17__/* .LabelS */ .ew, {
                                                    flex: "1 1 auto",
                                                    color: _styles_colors__WEBPACK_IMPORTED_MODULE_12__/* .colors.gray600 */ .O.gray600,
                                                    children: "관리자 페이지"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_14__/* .Icon */ .J, {
                                                    type: "ChevronRight",
                                                    size: 12
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            [
                                {
                                    name: "홈",
                                    icon: undefined,
                                    onClick: undefined,
                                    color: undefined,
                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_19__/* .Routes.HOME */ .Z.HOME
                                }, 
                            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((me === null || me === void 0 ? void 0 : me.professionalId) && [
                                {
                                    name: "해석 참여",
                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_19__/* .Routes.DOCTOR_EXAMINATIONS */ .Z.DOCTOR_EXAMINATIONS
                                },
                                {
                                    name: "나의 해석",
                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_19__/* .Routes.DOCTOR_INTERPRETATIONS */ .Z.DOCTOR_INTERPRETATIONS
                                },
                                {
                                    name: "정산 관리",
                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_19__/* .Routes.DOCTOR_EARNINGS */ .Z.DOCTOR_EARNINGS
                                },
                                {
                                    name: "내 정보",
                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_19__/* .Routes.DOCTOR_PROFILE */ .Z.DOCTOR_PROFILE
                                }, 
                            ] || []), [
                                {
                                    name: "내 검사 결과",
                                    icon: undefined,
                                    onClick: undefined,
                                    color: undefined,
                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_19__/* .Routes.PATIENT_EXAMINATIONS */ .Z.PATIENT_EXAMINATIONS
                                },
                                {
                                    name: "해석 요청",
                                    icon: undefined,
                                    onClick: undefined,
                                    color: undefined,
                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_19__/* .Routes.UPLOAD */ .Z.UPLOAD
                                },
                                {
                                    name: "계정 설정",
                                    icon: undefined,
                                    onClick: undefined,
                                    color: undefined,
                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_19__/* .Routes.SETTINGS_ACCOUNT */ .Z.SETTINGS_ACCOUNT
                                },
                                {
                                    name: "알림 설정",
                                    icon: undefined,
                                    onClick: undefined,
                                    color: undefined,
                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_19__/* .Routes.SETTINGS_NOTIFICATIONS */ .Z.SETTINGS_NOTIFICATIONS
                                },
                                {
                                    name: "문의 내역",
                                    icon: undefined,
                                    onClick: undefined,
                                    color: undefined,
                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_19__/* .Routes.SETTINGS_INQUIRIES */ .Z.SETTINGS_INQUIRIES
                                }, 
                            ]).map(function(param) {
                                var name = param.name, icon = param.icon, href = param.href, onClick = param.onClick, _color = param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_12__/* .colors.gray700 */ .O.gray700 : _color;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    onClick: function() {
                                        return setIsOpen(false);
                                    },
                                    children: [
                                        href && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: href,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                className: menuItemStyle,
                                                children: [
                                                    icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_14__/* .Icon */ .J, {
                                                        type: icon,
                                                        size: 20,
                                                        color: color
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_17__/* .LabelS */ .ew, {
                                                        flex: "1 1 auto",
                                                        color: color,
                                                        children: name
                                                    }),
                                                    icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_14__/* .Icon */ .J, {
                                                        type: "ChevronRight",
                                                        size: 12
                                                    })
                                                ]
                                            })
                                        }),
                                        Boolean(onClick) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: menuItemStyle,
                                            onClick: onClick,
                                            children: [
                                                icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_14__/* .Icon */ .J, {
                                                    type: icon,
                                                    size: 20,
                                                    color: color
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_17__/* .LabelS */ .ew, {
                                                    flex: "1 1 auto",
                                                    color: color,
                                                    children: name
                                                }),
                                                icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_14__/* .Icon */ .J, {
                                                    type: "ChevronRight",
                                                    size: 12
                                                })
                                            ]
                                        })
                                    ]
                                }, name);
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: menuItemStyle,
                                    onClick: logout,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_17__/* .LabelS */ .ew, {
                                        flex: "1 1 auto",
                                        children: "로그아웃"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 97006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ HeaderMenu; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(60369);
/* harmony import */ var _lib_routes__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(78954);
/* harmony import */ var _modules_auth_hooks_use_logout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84322);
/* harmony import */ var _modules_users_hooks_use_me__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17243);
/* harmony import */ var _styles_box_shadow__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(24035);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32317);
/* harmony import */ var _styles_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45500);
/* harmony import */ var baseui_popover__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(44409);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43281);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54511);
/* harmony import */ var _base_popover__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74732);
/* harmony import */ var _base_typography__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(67408);
/* harmony import */ var _icon__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(32079);
/* harmony import */ var _styles_media_query__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(97475);





















var HeaderMenu = function(param) {
    var menus = param.menus;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,styletron_react__WEBPACK_IMPORTED_MODULE_4__/* .useStyletron */ .hQ)(), 1), css = ref[0];
    var logout = (0,_modules_auth_hooks_use_logout__WEBPACK_IMPORTED_MODULE_5__/* .useLogout */ .a)().logout;
    var me = (0,_modules_users_hooks_use_me__WEBPACK_IMPORTED_MODULE_6__/* .useMe */ .P)().me;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var menuItemStyle = css((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        display: "flex",
        alignItems: "center",
        cursor: "pointer"
    }, (0,_styles_utils__WEBPACK_IMPORTED_MODULE_9__/* .transition */ .eR)("background-color", "0.2s"), (0,polished__WEBPACK_IMPORTED_MODULE_10__/* .padding */ .o3)("16px", "16px")), {
        ":hover": {
            backgroundColor: _styles_colors__WEBPACK_IMPORTED_MODULE_11__/* .colors.gray50 */ .O.gray50
        }
    }));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_popover__WEBPACK_IMPORTED_MODULE_12__/* .BasePopover */ .m, {
            dismissOnClickOutside: true,
            dismissOnEsc: true,
            triggerType: "click",
            placement: baseui_popover__WEBPACK_IMPORTED_MODULE_13__/* .PLACEMENT.bottomRight */ .r4.bottomRight,
            accessibilityType: "menu",
            content: function(param) {
                var close = param.close;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    className: css((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, (0,_styles_utils__WEBPACK_IMPORTED_MODULE_9__/* .border */ .Cg)(_styles_colors__WEBPACK_IMPORTED_MODULE_11__/* .colors.gray100 */ .O.gray100), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_9__/* .borderRadius */ .E0)(16), (0,polished__WEBPACK_IMPORTED_MODULE_10__/* .padding */ .o3)("4px", "0px")), {
                        backgroundColor: _styles_colors__WEBPACK_IMPORTED_MODULE_11__/* .colors.white */ .O.white,
                        minWidth: "200px",
                        overflow: "hidden"
                    })),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: css((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                rowGap: "8px"
                            }, (0,polished__WEBPACK_IMPORTED_MODULE_10__/* .padding */ .o3)("20px", "16px"), (0,_styles_box_shadow__WEBPACK_IMPORTED_MODULE_14__/* .boxShadow */ .W)("borderBottom"))),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_base_typography__WEBPACK_IMPORTED_MODULE_15__/* .LabelS */ .ew, {
                                    children: [
                                        me === null || me === void 0 ? void 0 : me.nickname,
                                        "님"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_typography__WEBPACK_IMPORTED_MODULE_15__/* .LabelS */ .ew, {
                                    color: _styles_colors__WEBPACK_IMPORTED_MODULE_11__/* .colors.gray400 */ .O.gray400,
                                    children: me === null || me === void 0 ? void 0 : me.email
                                })
                            ]
                        }),
                        (me === null || me === void 0 ? void 0 : me.role) === _lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_16__/* .UserRole.Admin */ .i4.Admin && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: close,
                                children: router.pathname.includes("admin") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_17__/* .Routes.HOME */ .Z.HOME,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: menuItemStyle,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_typography__WEBPACK_IMPORTED_MODULE_15__/* .LabelS */ .ew, {
                                                flex: "1 1 auto",
                                                color: _styles_colors__WEBPACK_IMPORTED_MODULE_11__/* .colors.gray600 */ .O.gray600,
                                                children: "온톨로 이동하기"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_18__/* .Icon */ .J, {
                                                type: "ChevronRight",
                                                size: 12
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_17__/* .AdminRoutes.HOME */ .i.HOME,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: menuItemStyle,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_typography__WEBPACK_IMPORTED_MODULE_15__/* .LabelS */ .ew, {
                                                flex: "1 1 auto",
                                                color: _styles_colors__WEBPACK_IMPORTED_MODULE_11__/* .colors.gray600 */ .O.gray600,
                                                children: "관리자 페이지"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_18__/* .Icon */ .J, {
                                                type: "ChevronRight",
                                                size: 12
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        menus.map(function(param) {
                            var name = param.name, icon = param.icon, href = param.href, onClick = param.onClick, _color = param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_11__/* .colors.gray700 */ .O.gray700 : _color;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                onClick: close,
                                children: [
                                    href && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: href,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            className: menuItemStyle,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_typography__WEBPACK_IMPORTED_MODULE_15__/* .LabelS */ .ew, {
                                                    flex: "1 1 auto",
                                                    color: color,
                                                    children: name
                                                }),
                                                icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_18__/* .Icon */ .J, {
                                                    type: "ChevronRight",
                                                    size: 12
                                                })
                                            ]
                                        })
                                    }),
                                    Boolean(onClick) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: menuItemStyle,
                                        onClick: onClick,
                                        children: [
                                            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_18__/* .Icon */ .J, {
                                                type: icon,
                                                size: 20,
                                                color: color
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_typography__WEBPACK_IMPORTED_MODULE_15__/* .LabelS */ .ew, {
                                                flex: "1 1 auto",
                                                color: color,
                                                children: name
                                            }),
                                            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_18__/* .Icon */ .J, {
                                                type: "ChevronRight",
                                                size: 12
                                            })
                                        ]
                                    })
                                ]
                            }, name);
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: menuItemStyle,
                                onClick: logout,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_typography__WEBPACK_IMPORTED_MODULE_15__/* .LabelS */ .ew, {
                                    flex: "1 1 auto",
                                    children: "로그아웃"
                                })
                            })
                        })
                    ]
                });
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                "aria-label": "header-menu",
                className: css((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, _styles_utils__WEBPACK_IMPORTED_MODULE_9__/* .flexCenter */ ._7), {
                    cursor: "pointer",
                    columnGap: "8px"
                }), (0,polished__WEBPACK_IMPORTED_MODULE_10__/* .padding */ .o3)("7px", "12px"), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_9__/* .border */ .Cg)(_styles_colors__WEBPACK_IMPORTED_MODULE_11__/* .colors.gray300 */ .O.gray300), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_9__/* .borderRadius */ .E0)(80), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_9__/* .transition */ .eR)("border-color")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({
                    backgroundColor: _styles_colors__WEBPACK_IMPORTED_MODULE_11__/* .colors.white */ .O.white,
                    boxSizing: "border-box",
                    ":hover": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, (0,_styles_utils__WEBPACK_IMPORTED_MODULE_9__/* .border */ .Cg)(_styles_colors__WEBPACK_IMPORTED_MODULE_11__/* .colors.gray500 */ .O.gray500)),
                    display: "none"
                }, _styles_media_query__WEBPACK_IMPORTED_MODULE_20__/* .mediaQuery.TABLET */ .c.TABLET, {
                    display: "flex"
                }))),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_18__/* .Icon */ .J, {
                        type: "Menu",
                        size: 20
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_18__/* .Icon */ .J, {
                        type: "Person",
                        size: 20
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 49965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ Logo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styletron-react/dist-browser-esm/index.js
var dist_browser_esm = __webpack_require__(54511);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./public/svg/logo/basic-logo.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgBasicLogo(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 200 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M53.298 28.114C53.298 10.06 41.602.246 26.802.246 11.85.246.268 10.06.23 28.114c.038 17.942 11.62 27.868 26.572 27.868 14.8 0 26.496-9.813 26.496-27.868zm-38.23 0c0-10 4.164-15.432 11.734-15.432 7.494 0 11.696 5.431 11.658 15.432.038 9.964-4.164 15.395-11.658 15.433-7.57-.038-11.734-5.47-11.734-15.433zm59.73 4.12c0-4.157 2.422-6.704 6.207-6.667 3.86-.037 6.132 2.472 6.056 6.667v23h14.308V29.312c.076-8.952-5.602-15.283-14.308-15.283-6.056 0-10.788 3.11-12.567 8.166h-.454v-7.641H60.49v40.678h14.307V32.235zm58.214-17.68h-7.191V4.817h-14.308v9.739h-5.299v10.263h5.299v18.804c-.114 8.465 5.261 12.173 15.216 12.21 3.218-.037 5.489-.262 6.813-.524V44.745c-1.627.15-3.747.263-4.769.225-2.006-.112-2.952-.862-2.952-2.772v-17.38h7.191V14.555zm25.285 41.428c13.248 0 21.159-8.465 21.121-20.976.038-12.51-7.873-20.976-21.121-20.976-13.248 0-21.159 8.466-21.197 20.976.038 12.511 7.949 20.976 21.197 20.976zm-6.586-21.05c.038-6.518 2.46-10.6 6.662-10.564 4.012-.037 6.472 4.046 6.434 10.563.038 6.443-2.422 10.526-6.434 10.563-4.202-.037-6.624-4.12-6.662-10.563zM199.933.994h-14.307v54.238h14.307V.995z",
    fill: "#000"
  })));
}
/* harmony default export */ var basic_logo = (SvgBasicLogo);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./lib/routes.ts
var routes = __webpack_require__(78954);
;// CONCATENATED MODULE: ./components/logo/logo.tsx








var logos = {
    icon: basic_logo,
    ko: basic_logo,
    en: basic_logo
};
var Logo = function(param) {
    var _type = param.type, type = _type === void 0 ? "en" : _type, _size = param.size, size = _size === void 0 ? "s" : _size, className = param.className, onClick = param.onClick, active = param.active, _href = param.href, href = _href === void 0 ? routes/* Routes.HOME */.Z.HOME : _href;
    var ref = (0,_sliced_to_array/* default */.Z)((0,dist_browser_esm/* useStyletron */.hQ)(), 1), css = ref[0];
    var Component = (0,react.useMemo)(function() {
        return logos[type];
    }, [
        type
    ]);
    var height = {
        xs: 16,
        s: 24,
        m: 32,
        l: 48,
        xl: 64
    }[size];
    var icon = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
            height: height,
            className: classnames_default()("logo", className, css({
                display: "inline-flex",
                cursor: Boolean(onClick) ? "pointer" : undefined
            })),
            onClick: onClick
        });
    }, [
        Component,
        className,
        css,
        height,
        onClick
    ]);
    return active ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            "aria-label": "ontol-logo",
            children: icon
        })
    }) : icon;
};


/***/ }),

/***/ 84322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useLogout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66252);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50319);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60369);
/* harmony import */ var _lib_utils_access_token__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65262);






var useLogout = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var client = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useApolloClient */ .x)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .useMutation */ .D)(_lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_5__/* .LogoutDocument */ .Kc, {
        onCompleted: function() {
            client.cache.evict({
                fieldName: "me"
            });
            router.replace(router.asPath);
            router.reload();
        }
    }), 1), logoutMutation = ref[0];
    var logout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        (0,_lib_utils_access_token__WEBPACK_IMPORTED_MODULE_6__/* .setAccessToken */ .M)("");
        logoutMutation();
    }, [
        logoutMutation
    ]);
    return {
        logout: logout
    };
};


/***/ }),

/***/ 17243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useMe; }
/* harmony export */ });
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6812);
/* harmony import */ var _lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60369);


var useMe = function() {
    var ref = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .useQuery */ .a)(_lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_1__/* .MeDocument */ .en, {
        errorPolicy: "ignore"
    }), data = ref.data, loading = ref.loading;
    return {
        me: data === null || data === void 0 ? void 0 : data.me,
        loading: loading
    };
};


/***/ }),

/***/ 45875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ HEADER_HEIGHT; }
/* harmony export */ });
var HEADER_HEIGHT = 72;


/***/ }),

/***/ 9227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ zIndexes; }
/* harmony export */ });
var zIndexes = {
    header: 5,
    footer: 4,
    sideNav: 3,
    // 10~99: modal
    baseModal: 10,
    detailModal: 11,
    confirmModal: 12,
    alretModal: 13,
    // 100~199: select, combobox, dropdown
    select: 100,
    // 200~299:  toast, image viewer
    imageViewer: 201,
    // 500~599:  toast
    toast: 500
};


/***/ })

}]);